import {
  useEffect,
  useMemo,
  useState,
} from 'react';
import { object, oneOf } from 'prop-types';

import imagotipo from 'assets/svg/imagotipo.svg';
import imagotipoDarkH from 'assets/svg/imagotipo-blue-h.svg';
import imagotipoHorizontal from 'assets/svg/imagotipo-horizontal.svg';
import { getSignedUrl } from 'utils/aws/s3';

function readLogos() {
  let logos;
  try {
    const company = JSON.parse(localStorage.getItem('company'));

    logos = company?.logo || {};
  } catch (e) {
    logos = {};
  } finally {
    return logos;
  }
}

function Logo({ style, variant }) {
  const logos = readLogos();

  const companyLogos = useMemo(() => ({
    imagotipo: logos.imagotipoHorizontal || imagotipo,
    'imagotipo-horizontal': logos.imagotipoHorizontal || imagotipoHorizontal,
    'imagotipo-horizontal-dark': logos.imagotipoDarkH || imagotipoDarkH,
  }), [logos.imagotipoDarkH, logos.imagotipoHorizontal]);
  const [resolvedLogos, setResolvedLogos] = useState(companyLogos);

  useEffect(() => {
    let isMounted = true;
    const s3Pattern = /^https:\/\/.+\.amazonaws\.com\//;

    const resolveLogos = async () => {
      const entries = await Promise.all(
        Object.entries(companyLogos).map(async ([key, url]) => {
          if (!s3Pattern.test(String(url || ''))) {
            return [key, url];
          }

          try {
            const signedUrl = await getSignedUrl(url, 60 * 60);

            return [key, signedUrl || url];
          } catch (error) {
            return [key, url];
          }
        }),
      );

      if (isMounted) {
        setResolvedLogos(Object.fromEntries(entries));
      }
    };

    resolveLogos();

    return () => {
      isMounted = false;
    };
  }, [companyLogos]);

  return (<img
    alt="Company logo"
    src={resolvedLogos[variant]}
    style={{
      height: '100px',
      ...style,
    }}
  />);
}

Logo.defaultProps = {
  company: 'a55',
  variant: 'imagotipo-horizontal-dark',
};

Logo.propTypes = {
  style: object,
  variant: oneOf([
    'imagotipo',
    'imagotipo-horizontal',
    'imagotipo-horizontal-dark',
  ]),
};

export default Logo;
